import { render, staticRenderFns } from "./associationRelationWarning.vue?vue&type=template&id=97210504&scoped=true"
import script from "./associationRelationWarning.vue?vue&type=script&lang=js"
export * from "./associationRelationWarning.vue?vue&type=script&lang=js"
import style0 from "./associationRelationWarning.vue?vue&type=style&index=0&id=97210504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97210504",
  null
  
)

export default component.exports